export function stopPageLoading() {
  // remove spinner: https://pathgather.github.io/please-wait/
  document.addEventListener('DOMContentLoaded', function() {
    let spiner = document.getElementById('page-loading-spinner')
    if (spiner !== undefined && spiner !== null) {
      spiner.remove()
    }
  })
}
